/**
 * Minimal History-API router. The app has a handful of fixed paths, so a routing library
 * would be more than it needs.
 */
import { useSyncExternalStore } from 'react';

const EVENT = 'app:navigate';

function subscribe(cb: () => void): () => void {
  window.addEventListener('popstate', cb);
  window.addEventListener(EVENT, cb);
  return () => {
    window.removeEventListener('popstate', cb);
    window.removeEventListener(EVENT, cb);
  };
}

const snapshot = (): string => window.location.pathname + window.location.search;

export function navigate(to: string, opts: { replace?: boolean } = {}): void {
  if (to === snapshot()) return;
  if (opts.replace) window.history.replaceState(null, '', to);
  else window.history.pushState(null, '', to);
  window.dispatchEvent(new Event(EVENT));
}

export interface Route {
  path: string;
  query: URLSearchParams;
}

export function useRoute(): Route {
  const href = useSyncExternalStore(subscribe, snapshot);
  const url = new URL(href, window.location.origin);
  return { path: url.pathname, query: url.searchParams };
}

/** Home of the phone (wallet) app: "/" for office boys; "/wallet" for people who also use the
 * owner app, whose "/" is the dashboard. Set by App on every render. */
let walletHome = '/';
export const WALLET_ALT_HOME = '/wallet';

export function setWalletHome(path: string): void {
  walletHome = path;
}

/** Back to the wallet app's home screen. */
export function goWalletHome(): void {
  navigate(walletHome, { replace: true });
}
